type TranslateFunction = (key: string) => string;

/**
 * 把後端回傳的列舉值（角色代碼、稽核動作…）轉成畫面用語。
 * 查不到翻譯時回傳原值：後端新增列舉值時畫面仍可辨識，而不是顯示成語系鍵。
 */
export function translateEnumValue(
    translate: TranslateFunction,
    group: string,
    value: string
): string {
    const translationKey = `${group}.${value}`;
    const translated = translate(translationKey);
    return translated === translationKey ? value : translated;
}
